import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'
import RadioButton from './RadioButton'

const Label = styled.label`
  display: inline-flex;
  gap: ${rem(16)};
`

const RadioText = styled(BodyText)`
  flex-grow: 1;
  transition: color 0.2s;
`

interface Props extends React.ComponentProps<typeof RadioButton> {}

function RadioButtonInput(props: Props) {
  const { children, className, ...inputProps } = props
  const hasChildren = React.Children.toArray(children).length !== 0

  return (
    <Label className={className} htmlFor={inputProps.id}>
      <RadioButton {...inputProps} />
      {hasChildren && <RadioText
        colour={inputProps.disabled ? 'neutral-six' : 'neutral-one'}
        variant="large"
        forwardedAs="span"
      >
        {children}
      </RadioText>}
    </Label>
  )
}

export default RadioButtonInput
